module.exports = __webpack_public_path__ + "images/help/video-invite-small-680db61a866827e3da565d6ee0676969.png";